export default __webpack_public_path__ + "static/media/logo.647795f9.svg";